export default __webpack_public_path__ + "static/media/Kontraktuebersicht_Vertrag.f74e0066.jpg";